import { useEffect } from "react";
import { toast } from "sonner";

const MimicLoader = ({ isLoading }: { isLoading: boolean }) => {
  useEffect(() => {
    if (isLoading) {
      const toastMessages = [
        "שולח את השאלה...",
        "מעבד את השאלה...",
        "מחפש במאגר המידע...",
        "מכין תשובה...",
        "מעדכן את התשובה...",
      ];

      const toastIds: (string | number)[] = [];
      let currentToastIndex = 0;

      // Create the first toast
      const firstToast = toast.loading(toastMessages[0]);
      toastIds.push(firstToast);

      // Create interval to show subsequent toasts every 3 seconds
      const toastInterval = setInterval(() => {
        if (currentToastIndex < toastMessages.length - 1) {
          // Dismiss previous toast
          toast.dismiss(toastIds[currentToastIndex]);

          // Show next toast
          currentToastIndex++;
          const newToast = toast.loading(toastMessages[currentToastIndex]);
          toastIds.push(newToast);
        }
      }, 3000);

      // Cleanup function to clear interval and dismiss toasts
      return () => {
        clearInterval(toastInterval);
        toastIds.forEach((id) => toast.dismiss(id));
      };
    }
  }, [isLoading]);
  return null;
};

export default MimicLoader;
